import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

// AFV dos clientes (containers na VPS do Google): listar, status, logs e as acoes
// iniciar, parar, reiniciar, backup, limpar e remover. Limpar e remover exigem o
// contrato digitado (confirmacao). So a equipe Speedy (a API recusa revenda).
class AfvService extends BaseService {
  constructor() {
    super(`${ConfigApi.afvURL}`);
  }

  async listar() {
    this.setLoading(true);
    try {
      const response = await this.api.get(this.url);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  // cpu, memoria e disco da VPS e cpu/memoria por container (sem o loading: roda junto da lista)
  async recursos() {
    const response = await this.api.get(`${this.url}/recursos`);
    return response.data;
  }

  async status(numeroContrato) {
    this.setLoading(true);
    try {
      const response = await this.api.get(`${this.url}/${numeroContrato}`);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  async logs(numeroContrato, linhas = 200) {
    this.setLoading(true);
    try {
      const response = await this.api.get(
        `${this.url}/${numeroContrato}/logs?linhas=${linhas}`
      );
      return response.data.logs;
    } finally {
      this.setLoading(false);
    }
  }

  async acao(numeroContrato, acao, confirmacao = '') {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/${numeroContrato}/${acao}`, {
        confirmacao,
      });
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }
}

export default new AfvService();
